import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api_comm from "../../common/lib";

let history;
export const getHistory = createAsyncThunk(
	"member/Histories",
	async (payload, { getState }) => {
		history = payload.history;
		const state = getState();

		try {
			// Get items.

			let endpoint =
				"/members/api/v2/history/" +
				state.Login.Auth.storemember_guid +
				"?history=" +
				history.toLowerCase();
			for (let [key, value] of Object.entries(payload.params)) {
				// console.log(`${key}: ${value}`);
				if (value !== "") {
					let times = ["start_date_time", "end_date_time"];
					if (times.includes(key)) {
						key = key.replace("_time", "");
					}
					endpoint += "&" + key + "=" + value;
				}
			}
			let Histories = await api_comm(
				"get",
				endpoint,
				{},
				state.Login.Auth.session_token
			);

			return Histories.data;
		} catch (e) {
			console.log("Error:::", e);
			throw new Error(e?.message);
		}
	}
);

export const getAttachment = createAsyncThunk(
	"claim/Attachment",
	async (payload, { getState }) => {
		const state = getState();

		try {
			// Get items.

			let endpoint = `/claims/api/v2/claim/data/${payload}`;
			let Attachment = await api_comm(
				"get",
				endpoint,
				{},
				state.Login.Auth.session_token
			);
			return Attachment.data;
		} catch (e) {
			console.log("Error:::", e);
			throw new Error(e?.message);
		}
	}
);

const initialState = {
	Histories: [],
	loading: false,
	Attachment: "",
};

export const HistorySlice = createSlice({
	name: "Histories",
	initialState,
	reducers: {
		setHistories: (state, action) => {
			state.Histories = { [history]: action.payload };
		},
		resetAttachment: (state, action) => {
			state.Attachment = action.payload;
		},
	},
	extraReducers: {
		[getHistory.pending]: (state, action) => {
			state.loading = true;
		},
		[getHistory.fulfilled]: (state, action) => {
			state.Histories = { [history]: action.payload };
			state.loading = false;
		},
		[getHistory.rejected]: (state, action) => {
			state.Histories = action.payload;
			state.loading = false;
		},
		[getAttachment.pending]: (state, action) => {
			state.loading = true;
		},
		[getAttachment.fulfilled]: (state, action) => {
			state.Attachment = action.payload;
			state.loading = false;
		},
		[getAttachment.rejected]: (state, action) => {
			state.Attachment = action.payload;
			state.loading = false;
		},
	},
});

export const { setHistories } = HistorySlice.actions;
export const { resetAttachment } = HistorySlice.actions;

export default HistorySlice.reducer;
